import uiSelectors from 'selectors/ui';
import uiEvents from 'events/ui';

import { getIsExistingUser, getIsMinimized } from 'app/modules';

import customButtonIsPresent from 'app/dom_mutators/isCustomButtonPresent';
import showCustomMinimizedButton from 'app/dom_mutators/showCustomMinimizedButton';

export default function showWidget() {
  return (dispatch, getState) => {
    const state = getState();
    const hasAuthenticated = getIsExistingUser(state);

    if (uiSelectors.getIsSupressedByRules(state.ui)) {
      return;
    }

    return getIsMinimized(state) && customButtonIsPresent()
      ? showCustomMinimizedButton(hasAuthenticated)
      : dispatch(uiEvents.updateVisibility(true));
  };
}
